const NotFound: React.FC = () => (
  <p>Page not found</p>
);
export default NotFound;
